import React from 'react';
import {ModalWrapper} from '../purchase-cta/processing-modals/modal-wrapper';

export interface LiFiCashOrCryptoProps {
  imageSrc?: string;
  trackName?: string;
  artist?: string;
  quantity: number;
  handleCashFlow: () => void;
  handleExchangeFlow: () => void;
  onModalClose: () => void;
}

export const LiFiCashOrCrypo: React.FC<LiFiCashOrCryptoProps> = ({
  imageSrc,
  trackName,
  artist,
  quantity,
  handleCashFlow,
  handleExchangeFlow,
  onModalClose,
}: LiFiCashOrCryptoProps) => {
  return (
    <ModalWrapper
      title="Payment Details"
      copyPrimary="Don't have enough tokens, try with cash or exchange."
      imageSrc={imageSrc}
      leftButton={{
        label: 'Try Cash Flow',
        handlePress: handleCashFlow,
      }}
      rightButton={{
        label: 'Exchange Tokens',
        handlePress: handleExchangeFlow,
      }}
      artist={artist}
      trackName={trackName}
      quantity={quantity}
      onModalClose={onModalClose}
    />
  );
};
